<template>
  <div class="my-page">
    <div class="billboard-person1">
      <el-row class="user-ranking-row">
        <el-col :span="8">
          <div class="user-ranking-img-box2">
            <img
                class="user-ranking-img-2"
                :src="userRankingData[1].avatar"
            /><br/>
          </div>
          <div class="user-ranking-name-box">
            <span class="user-ranking-name"
            >{{ userRankingData[1].nickname| ellipsis(6) }}
              <br><span class="user-ranking-integra">{{
                  userRankingData[1].integral
                }}</span></span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div class="user-ranking-img-box1">
            <img
                class="user-ranking-img-1"
                :src="userRankingData[0].avatar"
            /><br/>
          </div>
          <div class="user-ranking-name-box">
            <span class="user-ranking-name"
            >{{ userRankingData[0].nickname| ellipsis(6) }}
              <br><span class="user-ranking-integra">{{
                  userRankingData[0].integral
                }}</span></span
            >
          </div>
        </el-col>
        <el-col :span="8">
          <div class="user-ranking-img-box3">
            <img
                class="user-ranking-img-2"
                :src="userRankingData[2].avatar"
            /><br/>
          </div>
          <div class="user-ranking-name-box">
            <span class="user-ranking-name"
            >{{ userRankingData[2].nickname| ellipsis(6) }}
              <br><span class="user-ranking-integra">{{
                  userRankingData[2].integral
                }}</span></span
            >
          </div>
        </el-col>
      </el-row>
    </div>
    <div class="page">
      <div class="weui-form__control-area" style="margin: 0">
        <div class="weui-cells__group weui-cells__group_form">
          <div class="weui-cells weui-cells_form">
            <div class="weui-cell weui-cell_active">
              <div class="weui-cell__hd" style="margin-bottom: 8vh">
                <div v-for="(item, index) in userRankingData"
                     :value="item"
                     :key="index">
                  <el-row
                      class="my-row"
                      style="width:80vw"
                      :v-if="index>2"
                  >
                    <el-col class="my-col" :span="6"><span>{{ index + 1 }}</span></el-col>
                    <el-col class="my-col" :span="6"><img class="user-ranking-img-list" :src="item.avatar"/></el-col>
                    <el-col class="my-col" :span="6">
                      <div>
                        <span>{{ item.nickname }}</span>
                      </div>
                    </el-col>
                    <el-col class="my-col" :span="4" :offset="2">
                      <div>
                        <span>{{ item.integral }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="my-line"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {userRanking} from "@api/lesson";

export default {
  name: "PersonBoard",
  data: function () {
    return {
      userRankingData: [],
    };
  },
  mounted: function () {
    this.initRanking();
  },
  methods: {
    initRanking() {
      let loading = this.$weui.loading("数据加载中");
      let that = this;
      userRanking().then((res) => {
        that.userRankingData = res;
      });
      loading.hide();
    },
  },
  filters: {
    ellipsis(value, limit) {
      if (!value) return "";
      if (value.length > limit) {
        return value.slice(0, limit) + "...";
      }
      return value;
    },
  }
};
</script>

<style>
.my-page {
  width: 100%;
}

.billboard-person1 {
  position: relative;
  text-align: center;
  /*width: 100%;*/
  margin-top: 1vh;
  margin-left: 2vw;
  margin-right: 2vw;
  height: 35vh;
  background-size: 100% 100%; /*按比例缩放*/
  /*height: 100%;*/
  background-image: url("../../assets/images/billboard-person.png");
  /*background-size: contain;*/
  background-repeat: no-repeat;
  background-color: #66c5f5;
}

.user-ranking-row {
  margin-left: 15vw;
  width: 70vw;
  font-size: smaller;
}

.user-ranking-img-box2 {
  width: 10vh;
  height: 11vh;
  margin-top:12vh;
  background-image: url("../../assets/images/geren2-1.png");
  background-size: 100% 100%; /*按比例缩放*/
  background-repeat: no-repeat;
  text-align: center;
}
.user-ranking-img-box1 {
  width: 10vh;
  height: 11vh;
  margin-top:10vh;
  background-image: url("../../assets/images/geren1-1.png");
  background-size: 100% 100%; /*按比例缩放*/
  background-repeat: no-repeat;
  text-align: center;
}
.user-ranking-img-box3 {
  width: 10vh;
  height: 11vh;
  margin-top:13vh;
  background-image: url("../../assets/images/geren3-1.png");
  background-size: 100% 100%; /*按比例缩放*/
  background-repeat: no-repeat;
  text-align: center;
}
.user-ranking-integra {
  font-size: small;
  color: #e5e5e5;
  font-weight: lighter;
}

.user-ranking-img-1 {
  margin-top: 3.6vh;
  width: 65%;
  border-radius: 50%;
  overflow: hidden;
}

.user-ranking-img-2 {
  margin-top: 3.7vh;
  width: 65%;
  border-radius: 50%;
  overflow: hidden;
}


.user-ranking-name {
  font-size: small;
  color: #fafafa;
  font-weight: bolder;
  width: 100%;
}

.user-ranking-name-box {
  text-align: center;
  width: 90%;
  background-color: #66c5f5;
}

.user-ranking-img-list {
  width: 10vw;
  border-radius: 50%;
  overflow: hidden;
}

.my-row {
  height: 5vh;
  margin-top: 2vh;
  font-size: small;
}

.my-col {
  height: 100%;
  margin-bottom: 0;
}
</style>
